import ConfirmationDialog from './ConfirmationDialog';
import './ConfirmationDialog.scss';

export default ConfirmationDialog;
